import React, { FC } from 'react';

import { HelpFaqSettings } from '../../../../SideBar/SettingsModal/HelpFaqSettings';
import './HelpFaqSection.scss';

const HelpFaqSection: FC = () => {
  return (
    <div className="help-faq-section help-faq-section--new-tabs">
      <div className="help-faq-section__block">
        <HelpFaqSettings />
      </div>
    </div>
  );
};

export default HelpFaqSection;
